import { TRIAL_DAYS } from "../../../constants/trial";
import { LANDING_PRICE_FROM } from "../HomeLanding/landingSeo";

const SHARED_CONNECT = {
  kicker: "07 / ПОДКЛЮЧЕНИЕ",
  titleLines: ["Начнём с вашего", "рабочего дня"],
  lead:
    "Не нужно заранее перестраивать школу. Сначала посмотрим, подходит ли Бай.Спорт вашей команде.",
  steps: [
    {
      title: "Знакомимся",
      text: "Вы рассказываете о формате занятий, группах и команде.",
    },
    {
      title: "Показываем сервис",
      text: "Разбираем календарь, клиентов, посещения и общение на демо.",
    },
    {
      title: "Сверяем ожидания",
      text: "Уточняем ваши правила, состав возможностей и условия.",
    },
    {
      title: "Планируем запуск",
      text: "Согласуем данные, участников и последовательность подключения.",
    },
  ],
};

const SHARED_APP = {
  kicker: "04 / КЛУБ В ТЕЛЕФОНЕ",
  titleLines: ["Клуб рядом —", "даже когда вы не в зале"],
  owner: {
    kicker: "ДЛЯ ВЛАДЕЛЬЦА",
    titleLines: ["Рабочий день —", "перед глазами"],
    text:
      "Календарь занятий и текущие дела клуба доступны владельцу в приложении. Можно вернуться к клиентам и группам без поиска таблицы.",
    tags: "Клиенты · Группы · Календарь",
  },
  client: {
    kicker: "ДЛЯ КЛИЕНТА",
    titleLines: ["Быть на связи", "со своим клубом"],
    text:
      "Взрослый ученик видит занятия, свой абонемент и чат. Сценарий доступа родителей к данным ребёнка уточним на встрече.",
    tags: "Занятия · Абонемент · Чат",
  },
  fine: "Реальные экраны Бай.Спорт. «Тигр» — пример клуба внутри приложения.",
};

const SHARED_FEATURES_BASE = {
  kicker: "02 / ВОЗМОЖНОСТИ БАЙ.СПОРТ",
  titleLines: ["От списка учеников", "до следующей тренировки"],
  lead:
    "Клиенты, группы, календарь и абонементы — связанные части ежедневной работы, а не отдельные списки.",
  cards: [
    {
      icon: "icon-calendar.svg",
      title: "Ученики и группы",
      text:
        "Карточки клиентов и составы групп помогают держать детские и взрослые занятия в понятной структуре.",
    },
    {
      icon: "icon-calendar.svg",
      title: "Календарь клуба",
      text:
        "Занятия и группы в календаре: команде проще ориентироваться в расписании тренеров на день.",
    },
    {
      icon: "icon-calendar.svg",
      title: "Посещения и абонементы",
      text:
        "Отмечайте посещения и смотрите остатки занятий. У разговора о продлении появляется понятная основа.",
    },
  ],
  midCta: {
    title: "Клубная связь вместо потерянных сообщений",
    text:
      "Чат рядом с занятиями и профилем. На демо отдельно разберём, как организовать общение с родителями и взрослыми учениками.",
  },
};

/**
 * Собирает полный объект ниши: общие блоки + отраслевые тексты.
 */
function buildNiche(partial) {
  return {
    ...partial,
    heroCta: partial.heroCta || "Запросить персональное демо",
    heroNote: partial.heroNote || "Покажем сервис на задачах вашего бизнеса",
    features: { ...SHARED_FEATURES_BASE, ...partial.features },
    app: { ...SHARED_APP, ...partial.app },
    connect: { ...SHARED_CONNECT, ...partial.connect },
    faqIntro: partial.faqIntro || {
      kicker: "08 / ВОПРОСЫ",
      titleLines: ["До первого", "знакомства"],
      lead: "Что важно уточнить перед выбором CRM для вашего формата.",
    },
    form: {
      kicker: "09 / ОБСУДИМ ВАШ БИЗНЕС",
      tags: ["Ваши задачи", "Реальные экраны", "Следующий шаг"],
      ...partial.form,
    },
  };
}

export const NICHE_LANDINGS = {
  edinoborstva: buildNiche({
    id: "edinoborstva",
    path: "/dlya-edinoborstv",
    metrika: "niche_edinoborstva",
    label: "Единоборства",
    schoolNoun: "клубов единоборств",
    sports: ["карате", "бокс", "самбо", "дзюдо", "тхэквондо", "ММА"],
    seo: {
      title: "Бай.Спорт для клубов единоборств — CRM и приложение",
      description:
        `Ученики, группы, посещения и связь с родителями в одном сервисе для школ карате, бокса, самбо и ММА. ` +
        `${TRIAL_DAYS} дней бесплатно, от ${LANDING_PRICE_FROM} ₽/мес.`,
      keywords: [
        "crm для школы единоборств",
        "программа для клуба карате",
        "журнал посещаемости единоборства",
        "приложение для секции бокса",
      ],
    },
    contextLabel: "Единоборства",
    pill: "CRM ДЛЯ КЛУБОВ И ШКОЛ ЕДИНОБОРСТВ",
    heroLines: ["Дисциплина в зале.", "Порядок в клубе."],
    heroLead:
      "Ученики, детские и взрослые группы, посещения и связь с родителями — в одном рабочем контексте Бай.Спорт.",
    trustItems: [
      "Составы групп",
      "Расписание тренеров",
      "Посещения и остатки",
      "Общение с клубом",
    ],
    pains: {
      kicker: "01 / ЗНАКОМО ВАШЕЙ КОМАНДЕ?",
      titleLines: ["Группы растут.", "Детали не должны теряться."],
      cards: [
        {
          title: "Состав группы — в разных списках",
          text:
            "У тренера своя таблица, у администратора — переписка. Перед занятием приходится заново уточнять, кто придёт.",
        },
        {
          title: "Остатки считают вручную",
          text:
            "Ученик спрашивает, сколько тренировок осталось. Ответ требует проверить записи и последние посещения.",
        },
        {
          title: "Родители ищут информацию",
          text:
            "Время занятия и вопросы по абонементу теряются среди сообщений нескольких детских групп.",
        },
      ],
    },
    day: {
      kicker: "03 / ОТ ЗАНЯТИЯ К ЗАНЯТИЮ",
      titleLines: ["Вечерняя группа —", "без поисков по чатам"],
      lead:
        "Иллюстративный сценарий школы единоборств: младшая группа заканчивает занятие, взрослая готовится выйти на татами.",
      steps: [
        {
          label: "ДО",
          title: "Посмотреть день в календаре",
          text: "Администратор уточняет время и группу предстоящей тренировки.",
        },
        {
          label: "В ЗАЛЕ",
          title: "Открыть состав и отметить посещения",
          text: "Тренер и команда работают с одним контекстом занятия.",
        },
        {
          label: "ПОСЛЕ",
          title: "Проверить остаток и продолжить разговор",
          text: "Вопрос по абонементу не остаётся отдельной заметкой в телефоне.",
        },
      ],
    },
    rules: {
      kicker: "06 / НЕ ПОДГОНЯЕМ ВАС ПОД ШАБЛОН",
      titleLines: ["У каждой школы —", "свои правила"],
      items: [
        {
          title: "Дети и родители",
          text:
            "Обсудим контакты семьи, доступ к информации и ваш привычный порядок общения.",
        },
        {
          title: "Возраст и подготовка",
          text:
            "Разберём составы групп, переходы учеников и то, как команда различает уровни.",
        },
        {
          title: "Сборы и аттестации",
          text:
            "Если эти процессы важны, проверим подходящий сценарий. Не обещаем специальный учёт без обсуждения.",
        },
      ],
      note:
        "Специальные правила учёта, перенос данных и подключения обсуждаем отдельно — до решения о запуске.",
    },
    faq: [
      {
        q: "Подойдёт ли сервис для детских и взрослых групп?",
        a: "В Бай.Спорт есть клиенты, группы и календарь. На демо покажем эти разделы и разберём вашу структуру школы.",
      },
      {
        q: "Можно ли работать с родителями учеников?",
        a: "Обсудим, кто общается с клубом от имени ребёнка и какие сведения нужны семье. Сценарии доступа и ограничения уточняются отдельно.",
      },
      {
        q: "Где смотреть посещения и остатки занятий?",
        a: "На демонстрации пройдём путь от занятия и отметки посещения до информации по абонементу в приложении.",
      },
      {
        q: "Как перенести наши списки и узнать стоимость?",
        a: "Посмотрим ваши исходные таблицы и объём данных. Возможность переноса, состав запуска и условия согласуем после знакомства.",
      },
    ],
    form: {
      titleLines: ["Пусть тренер ведёт занятие.", "А процессы будут понятны."],
      lead:
        "Расскажите о вашей школе единоборств. Покажем Бай.Спорт на сценариях учеников, групп и посещений.",
    },
  }),

  tancy: buildNiche({
    id: "tancy",
    path: "/dlya-tancev",
    metrika: "niche_tancy",
    label: "Танцы",
    schoolNoun: "танцевальных школ",
    sports: ["хип-хоп", "балет", "contemporary", "хореография", "stretch"],
    seo: {
      title: "Бай.Спорт для танцевальных школ — CRM и приложение",
      description:
        `Направления, составы на репетиции, абонементы и кабинет родителей в одном сервисе. ` +
        `${TRIAL_DAYS} дней бесплатно, от ${LANDING_PRICE_FROM} ₽/мес.`,
      keywords: [
        "crm для школы танцев",
        "программа для танцевальной студии",
        "журнал посещаемости танцы",
      ],
    },
    contextLabel: "Танцы",
    pill: "CRM ДЛЯ ТАНЦЕВАЛЬНЫХ ШКОЛ И СТУДИЙ",
    heroLines: ["Ритм на сцене.", "Порядок в студии."],
    heroLead:
      "Направления, составы, посещения и связь с родителями — в одном рабочем контексте Бай.Спорт.",
    trustItems: [
      "Составы направлений",
      "Расписание залов",
      "Посещения и остатки",
      "Общение со студией",
    ],
    pains: {
      kicker: "01 / ЗНАКОМО ВАШЕЙ КОМАНДЕ?",
      titleLines: ["Группы растут.", "Детали не должны теряться."],
      cards: [
        {
          title: "Составы живут в переписке",
          text:
            "У хореографа свой список, у администратора — чат. Перед репетицией снова уточняют, кто придёт.",
        },
        {
          title: "Остатки считают вручную",
          text:
            "Родитель спрашивает, сколько уроков осталось. Ответ — в таблице и последних отметках.",
        },
        {
          title: "Переносы теряются в чатах",
          text:
            "Время занятия и анонсы показов растворяются среди сообщений нескольких групп.",
        },
      ],
    },
    day: {
      kicker: "03 / ОТ ЗАНЯТИЯ К ЗАНЯТИЮ",
      titleLines: ["Вечерняя репетиция —", "без поисков по чатам"],
      lead:
        "Иллюстративный сценарий студии: детская группа заканчивает урок, подростки готовятся к показу.",
      steps: [
        {
          label: "ДО",
          title: "Посмотреть день в календаре",
          text: "Администратор уточняет зал, время и направление.",
        },
        {
          label: "В ЗАЛЕ",
          title: "Открыть состав и отметить посещения",
          text: "Педагог и команда работают с одним контекстом занятия.",
        },
        {
          label: "ПОСЛЕ",
          title: "Проверить остаток и продолжить разговор",
          text: "Вопрос по абонементу не остаётся заметкой в телефоне.",
        },
      ],
    },
    rules: {
      kicker: "06 / НЕ ПОДГОНЯЕМ ВАС ПОД ШАБЛОН",
      titleLines: ["У каждой студии —", "свои правила"],
      items: [
        {
          title: "Дети и родители",
          text: "Обсудим доступ семьи к расписанию и привычный порядок общения.",
        },
        {
          title: "Направления и залы",
          text: "Разберём стили, возрасты и как команда ведёт несколько площадок.",
        },
        {
          title: "Показы и сборы",
          text: "Если события важны, проверим подходящий сценарий на демо.",
        },
      ],
      note:
        "Специальные правила учёта и перенос данных обсуждаем отдельно — до решения о запуске.",
    },
    faq: [
      {
        q: "Подойдёт ли сервис для нескольких направлений?",
        a: "Да. На демо разберём структуру направлений, групп и календаря под вашу студию.",
      },
      {
        q: "Можно ли работать с родителями?",
        a: "Обсудим, кто видит расписание и остаток абонемента. Сценарии доступа уточняются отдельно.",
      },
      {
        q: "Где смотреть посещения и остатки?",
        a: "Пройдём путь от отметки на занятии до информации в приложении.",
      },
      {
        q: "Как перенести списки и узнать стоимость?",
        a: "Посмотрим ваши таблицы и объём данных. Условия согласуем после знакомства.",
      },
    ],
    form: {
      titleLines: ["Пусть педагог ведёт занятие.", "А процессы будут понятны."],
      lead:
        "Расскажите о вашей танцевальной школе. Покажем Бай.Спорт на сценариях учеников, групп и посещений.",
    },
  }),

  gimnastika: buildNiche({
    id: "gimnastika",
    path: "/dlya-gimnastiki",
    metrika: "niche_gimnastika",
    label: "Гимнастика",
    schoolNoun: "гимнастических секций",
    sports: ["художественная", "спортивная", "акробатика", "cheer"],
    seo: {
      title: "Бай.Спорт для секций гимнастики — CRM и приложение",
      description:
        `Группы по уровням, журнал в зале, абонементы и связь с родителями. ` +
        `${TRIAL_DAYS} дней бесплатно, от ${LANDING_PRICE_FROM} ₽/мес.`,
      keywords: [
        "crm для гимнастики",
        "программа для секции акробатики",
        "журнал посещаемости гимнастика",
      ],
    },
    contextLabel: "Гимнастика",
    pill: "CRM ДЛЯ ГИМНАСТИКИ И АКРОБАТИКИ",
    heroLines: ["Точность на снаряде.", "Порядок в секции."],
    heroLead:
      "Группы по возрастам и подготовке, посещения и связь с родителями — в одном контексте Бай.Спорт.",
    trustItems: [
      "Составы групп",
      "Расписание тренеров",
      "Посещения и остатки",
      "Общение с секцией",
    ],
    pains: {
      kicker: "01 / ЗНАКОМО ВАШЕЙ КОМАНДЕ?",
      titleLines: ["Группы растут.", "Детали не должны теряться."],
      cards: [
        {
          title: "Составы — в разных списках",
          text:
            "У тренера блокнот, у администратора — чат. Перед тренировкой снова уточняют состав.",
        },
        {
          title: "Остатки считают вручную",
          text:
            "Родитель спрашивает про абонемент — ответ требует сверить записи и посещения.",
        },
        {
          title: "Родители ищут информацию",
          text:
            "Время занятия и вопросы по оплате теряются среди сообщений нескольких групп.",
        },
      ],
    },
    day: {
      kicker: "03 / ОТ ЗАНЯТИЯ К ЗАНЯТИЮ",
      titleLines: ["Вечерняя группа —", "без поисков по чатам"],
      lead:
        "Иллюстративный сценарий секции: младшая группа заканчивает занятие, старшая готовится к снарядам.",
      steps: [
        {
          label: "ДО",
          title: "Посмотреть день в календаре",
          text: "Администратор уточняет время, зал и группу.",
        },
        {
          label: "В ЗАЛЕ",
          title: "Открыть состав и отметить посещения",
          text: "Тренер работает с одним контекстом занятия.",
        },
        {
          label: "ПОСЛЕ",
          title: "Проверить остаток и продолжить разговор",
          text: "Вопрос по абонементу не остаётся отдельной заметкой.",
        },
      ],
    },
    rules: {
      kicker: "06 / НЕ ПОДГОНЯЕМ ВАС ПОД ШАБЛОН",
      titleLines: ["У каждой секции —", "свои правила"],
      items: [
        {
          title: "Дети и родители",
          text: "Обсудим доступ семьи к расписанию и порядок общения.",
        },
        {
          title: "Уровни подготовки",
          text: "Разберём группы, переходы и как команда различает разряды.",
        },
        {
          title: "Сборы и соревнования",
          text: "Если эти процессы важны — проверим сценарий на демо.",
        },
      ],
      note:
        "Специальные правила учёта и перенос данных обсуждаем отдельно — до решения о запуске.",
    },
    faq: [
      {
        q: "Подойдёт ли сервис для групп разного уровня?",
        a: "Да. На демо разберём структуру групп, календаря и посещений под вашу секцию.",
      },
      {
        q: "Можно ли работать с родителями?",
        a: "Обсудим доступ к расписанию и абонементу. Сценарии уточняются отдельно.",
      },
      {
        q: "Где смотреть посещения и остатки?",
        a: "Пройдём путь от отметки в зале до информации в приложении.",
      },
      {
        q: "Как перенести списки и узнать стоимость?",
        a: "Посмотрим ваши таблицы. Условия согласуем после знакомства.",
      },
    ],
    form: {
      titleLines: ["Пусть тренер ведёт занятие.", "А процессы будут понятны."],
      lead:
        "Расскажите о вашей гимнастической секции. Покажем Бай.Спорт на сценариях учеников, групп и посещений.",
    },
  }),

  plavanie: buildNiche({
    id: "plavanie",
    path: "/dlya-plavaniya",
    metrika: "niche_plavanie",
    label: "Плавание",
    schoolNoun: "школ плавания",
    sports: ["обучение", "спорт", "взрослые", "аквааэробика"],
    seo: {
      title: "Бай.Спорт для школ плавания — CRM и приложение",
      description:
        `Группы у бортика, посещения, абонементы и связь с родителями в одном сервисе. ` +
        `${TRIAL_DAYS} дней бесплатно, от ${LANDING_PRICE_FROM} ₽/мес.`,
      keywords: [
        "crm для школы плавания",
        "программа для секции бассейна",
        "журнал посещаемости плавание",
      ],
    },
    contextLabel: "Плавание",
    pill: "CRM ДЛЯ ШКОЛ ПЛАВАНИЯ И БАССЕЙНОВ",
    heroLines: ["Ритм у бортика.", "Порядок в школе."],
    heroLead:
      "Группы по уровням, посещения и связь с родителями — в одном рабочем контексте Бай.Спорт.",
    trustItems: [
      "Составы групп",
      "Расписание дорожек",
      "Посещения и остатки",
      "Общение со школой",
    ],
    pains: {
      kicker: "01 / ЗНАКОМО ВАШЕЙ КОМАНДЕ?",
      titleLines: ["Группы растут.", "Детали не должны теряться."],
      cards: [
        {
          title: "Списки у бортика и в чате",
          text:
            "У тренера своя таблица, у администратора — переписка. Перед занятием снова уточняют состав.",
        },
        {
          title: "Остатки считают вручную",
          text:
            "Родитель спрашивает про абонемент — нужно сверить записи и последние посещения.",
        },
        {
          title: "Родители ищут информацию",
          text:
            "Время занятия и вопросы по оплате теряются среди сообщений нескольких групп.",
        },
      ],
    },
    day: {
      kicker: "03 / ОТ ЗАНЯТИЯ К ЗАНЯТИЮ",
      titleLines: ["Вечерняя группа —", "без поисков по чатам"],
      lead:
        "Иллюстративный сценарий школы плавания: младшая группа заканчивает занятие, следующая готовится к дорожке.",
      steps: [
        {
          label: "ДО",
          title: "Посмотреть день в календаре",
          text: "Администратор уточняет время, дорожку и группу.",
        },
        {
          label: "У БОРТИКА",
          title: "Открыть состав и отметить посещения",
          text: "Тренер работает с одним контекстом занятия.",
        },
        {
          label: "ПОСЛЕ",
          title: "Проверить остаток и продолжить разговор",
          text: "Вопрос по абонементу не остаётся заметкой в телефоне.",
        },
      ],
    },
    rules: {
      kicker: "06 / НЕ ПОДГОНЯЕМ ВАС ПОД ШАБЛОН",
      titleLines: ["У каждой школы —", "свои правила"],
      items: [
        {
          title: "Дети и родители",
          text: "Обсудим доступ семьи к расписанию и порядок общения.",
        },
        {
          title: "Уровни и дорожки",
          text: "Разберём группы обучения и спорта, наполняемость и расписание.",
        },
        {
          title: "Смены и бассейн",
          text: "Если площадка и слоты специфичны — проверим сценарий на демо.",
        },
      ],
      note:
        "Специальные правила учёта и перенос данных обсуждаем отдельно — до решения о запуске.",
    },
    faq: [
      {
        q: "Подойдёт ли сервис для детских и взрослых групп?",
        a: "Да. На демо разберём структуру групп, календаря и посещений под вашу школу.",
      },
      {
        q: "Можно ли работать с родителями?",
        a: "Обсудим доступ к расписанию и абонементу. Сценарии уточняются отдельно.",
      },
      {
        q: "Где смотреть посещения и остатки?",
        a: "Пройдём путь от отметки у бортика до информации в приложении.",
      },
      {
        q: "Как перенести списки и узнать стоимость?",
        a: "Посмотрим ваши таблицы. Условия согласуем после знакомства.",
      },
    ],
    form: {
      titleLines: ["Пусть тренер ведёт занятие.", "А процессы будут понятны."],
      lead:
        "Расскажите о вашей школе плавания. Покажем Бай.Спорт на сценариях учеников, групп и посещений.",
    },
  }),

  futbol: buildNiche({
    id: "futbol",
    path: "/dlya-futbola",
    metrika: "niche_futbol",
    label: "Футбол",
    schoolNoun: "футбольных секций",
    sports: ["U9", "U12", "U15", "любители", "ДЮСШ"],
    seo: {
      title: "Бай.Спорт для футбольных секций — CRM и приложение",
      description:
        `Команды по возрастам, журнал на поле, абонементы и связь с родителями. ` +
        `${TRIAL_DAYS} дней бесплатно, от ${LANDING_PRICE_FROM} ₽/мес.`,
      keywords: [
        "crm для футбольной секции",
        "программа для дюсш",
        "журнал посещаемости футбол",
      ],
    },
    contextLabel: "Футбол",
    pill: "CRM ДЛЯ ФУТБОЛЬНЫХ СЕКЦИЙ И ДЮСШ",
    heroLines: ["Игра на поле.", "Порядок в секции."],
    heroLead:
      "Команды, посещения и связь с родителями — в одном рабочем контексте Бай.Спорт.",
    trustItems: [
      "Составы команд",
      "Расписание тренеров",
      "Посещения и остатки",
      "Общение с секцией",
    ],
    pains: {
      kicker: "01 / ЗНАКОМО ВАШЕЙ КОМАНДЕ?",
      titleLines: ["Команды растут.", "Детали не должны теряться."],
      cards: [
        {
          title: "Состав — в командном чате",
          text:
            "У тренера свой список, у администратора — переписка. Перед тренировкой снова уточняют, кто выйдет.",
        },
        {
          title: "Взносы считают вручную",
          text:
            "Родитель спрашивает про оплату — ответ требует сверить таблицы и посещения.",
        },
        {
          title: "Родители ищут информацию",
          text:
            "Время тренировки и вопросы по абонементу теряются среди сообщений нескольких команд.",
        },
      ],
    },
    day: {
      kicker: "03 / ОТ ЗАНЯТИЯ К ЗАНЯТИЮ",
      titleLines: ["Вечерняя тренировка —", "без поисков по чатам"],
      lead:
        "Иллюстративный сценарий секции: младшая команда заканчивает занятие, старшая готовится выйти на поле.",
      steps: [
        {
          label: "ДО",
          title: "Посмотреть день в календаре",
          text: "Администратор уточняет время, поле и команду.",
        },
        {
          label: "НА ПОЛЕ",
          title: "Открыть состав и отметить посещения",
          text: "Тренер работает с одним контекстом тренировки.",
        },
        {
          label: "ПОСЛЕ",
          title: "Проверить остаток и продолжить разговор",
          text: "Вопрос по взносу не остаётся отдельной заметкой.",
        },
      ],
    },
    rules: {
      kicker: "06 / НЕ ПОДГОНЯЕМ ВАС ПОД ШАБЛОН",
      titleLines: ["У каждой секции —", "свои правила"],
      items: [
        {
          title: "Дети и родители",
          text: "Обсудим доступ семьи к расписанию и порядок общения.",
        },
        {
          title: "U-команды",
          text: "Разберём возрасты, переходы игроков и расписание полей.",
        },
        {
          title: "Сборы и турниры",
          text: "Если события важны — проверим подходящий сценарий на демо.",
        },
      ],
      note:
        "Специальные правила учёта и перенос данных обсуждаем отдельно — до решения о запуске.",
    },
    faq: [
      {
        q: "Подойдёт ли сервис для команд разных возрастов?",
        a: "Да. На демо разберём структуру команд, календаря и посещений под вашу секцию.",
      },
      {
        q: "Можно ли работать с родителями?",
        a: "Обсудим доступ к расписанию и абонементу. Сценарии уточняются отдельно.",
      },
      {
        q: "Где смотреть посещения и остатки?",
        a: "Пройдём путь от отметки на поле до информации в приложении.",
      },
      {
        q: "Как перенести списки и узнать стоимость?",
        a: "Посмотрим ваши таблицы. Условия согласуем после знакомства.",
      },
    ],
    form: {
      titleLines: ["Пусть тренер ведёт занятие.", "А процессы будут понятны."],
      lead:
        "Расскажите о вашей футбольной секции. Покажем Бай.Спорт на сценариях игроков, команд и посещений.",
    },
  }),
};

export const NICHE_LANDING_LIST = Object.values(NICHE_LANDINGS);

export function getNicheLanding(id) {
  return NICHE_LANDINGS[id] || null;
}
